module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_19.8f5b3cee.png";